import React from "react";

// Simple line-drawn ibex silhouette; used as a subtle watermark in the About section.
// Not photoreal — a stylized mountain-goat glyph, easy to swap with final logo later.
export const IbexMark = ({ className = "", strokeWidth = 1.25 }) => (
  <svg
    viewBox="0 0 240 240"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* horns */}
    <path d="M118 44 C 110 58, 100 76, 92 96 C 88 108, 88 118, 92 128" />
    <path d="M128 42 C 138 58, 150 76, 158 96 C 162 108, 162 118, 158 128" />
    {/* head */}
    <path d="M104 118 C 108 130, 120 138, 132 132 C 140 128, 146 118, 144 108" />
    <path d="M100 128 C 98 140, 108 150, 122 148" />
    {/* beard */}
    <path d="M118 148 L 116 168" />
    {/* neck + body */}
    <path d="M132 148 C 156 152, 176 166, 188 190" />
    <path d="M118 152 C 96 158, 78 172, 66 194" />
    {/* back arch */}
    <path d="M138 154 C 170 160, 196 176, 210 202" />
    {/* legs */}
    <path d="M80 194 L 78 216" />
    <path d="M96 200 L 96 220" />
    <path d="M170 200 L 170 220" />
    <path d="M188 194 L 190 216" />
    {/* ledge */}
    <path d="M40 224 L 210 224" opacity="0.55" />
  </svg>
);
